import axios from 'axios'

export default {
    getNotifications: (page = 1, unreadOnly = false, rfc = '') => axios.get('notifications', { params: { page, unread_only: unreadOnly, rfc } }),
    markAsRead: (id = null, rfc = '') => axios.post('notifications/read', id ? { id, rfc } : { rfc }),
    getUnreadCount: (rfc = '') => axios.get('notifications/unread-count', { params: { rfc } }),
    deleteNotification: (id) => axios.delete('notifications/delete', { data: { id } }),
    deleteReadNotifications: (rfc = '') => axios.delete('notifications/delete-read', { data: { rfc } }),
    getNotificationCfdis: (id) => axios.get(`notifications/${id}/cfdis`),
}
